<template>
  <div class="wrapper">
    <div class="card small-card solo-card">
      <h2>Sign Up</h2>

      <form @submit.prevent="handleSignup">
        <div class="input-group">
          <label for="email">Email</label>
          <input class="input" id="email" type="email" v-model="email" />
        </div>
        <div class="input-group">
          <label for="password">Password</label>
          <input class="input" id="password" type="password" v-model="password" />
        </div>
        <div class="button-list">
          <router-link to="/login" class="button-secondary"
            >Log In Instead</router-link
          >
          <button type="submit" class="button button-primary">
            Create Account
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { supabase } from "../supabase";

export default {
  setup() {
    const email = ref("");
    const password = ref("");

    const handleSignup = async () => {
      try {
        // Use the Supabase provided method to handle the signup
        const { error } = await supabase.auth.signUp({
          email: email.value,
          password: password.value,
        });
        if (error) throw error;

      } catch (error) {
        alert(error.error_description || error.message);
      }
    };

    return {
      email,
      password,
      handleSignup,
    };
  },
};
</script>
